import { Snackbar } from "@mcleod/components";
import { LMECompanySettings, LMEUserSettings } from "@mcleod/general";
import { AutogenLayoutAgedSettlementsReport } from "./autogen/AutogenLayoutAgedSettlementsReport";

export class AgedSettlementsReport extends AutogenLayoutAgedSettlementsReport {
    override onLoad(): void {
        this.textboxReportBy.selectedItem = this.textboxReportBy.items[0];
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
        const companySettings = LMECompanySettings.getSingleton();
        this.configurePayeeTypes(companySettings);
        this.setPayeeDefaultsFromUser(companySettings);
    }

    configurePayeeTypes(companySettings: LMECompanySettings) {
        if (companySettings?.isAsset()) {
            this.checkboxCompanyDriver.visible = true;
            this.checkboxOwnerOps.visible = true;
        } else {
            this.checkboxCompanyDriver.visible = false;
            this.checkboxOwnerOps.visible = false;
        }
    }

    setPayeeDefaultsFromUser(companySettings: LMECompanySettings) {
        const userSettings = LMEUserSettings.get();
        if (companySettings?.isAsset()) {
            if (userSettings?.type_company_drs === "Y") {
                this.checkboxCompanyDriver.checked = true;
            }
            if (userSettings?.type_owner_oper === "Y") {
                this.checkboxOwnerOps.checked = true;
            }
        }

        if (userSettings?.type_agents === "Y") {
            this.checkboxAgent.checked = true;
        }

        if (userSettings?.type_carrier === "Y") {
            this.checkboxCarriers.checked = true;
        }

    }

    validateIncludePayeeType(): boolean {
        return (
            this.checkboxCompanyDriver.checked ||
            this.checkboxCarriers.checked ||
            this.checkboxAgent.checked ||
            this.checkboxOwnerOps.checked
        );
    }

    checkboxCompanyDriverOnChange(){
        if(!this.validateIncludePayeeType()){
            Snackbar.showWarningSnackbar("At least ONE payee must be checked to run this report");
            this.checkboxCompanyDriver.checked = true;
        }
    }

    checkboxOwnerOpsOnChange(){
        if(!this.validateIncludePayeeType()){
            Snackbar.showWarningSnackbar("At least ONE payee must be checked to run this report");
            this.checkboxOwnerOps.checked = true;
        }
    }

    checkboxAgentOnChange(){
        if(!this.validateIncludePayeeType()){
            Snackbar.showWarningSnackbar("At least ONE payee must be checked to run this report");
            this.checkboxAgent.checked = true;
        }
    }

    pageBreakCheked() {
        const pageBreak = this.checkboxPageBreakAfterManager.checked;
        if(pageBreak){
            this.switchGroupByCarrierManager.checked = true;
        }
    }

    groupByCarrierManagerUncheked() {
        const groupBy = this.switchGroupByCarrierManager.checked;
        if(!groupBy){
            this.checkboxPageBreakAfterManager.checked = false;
        }
    }

    carrierPayeeTypeOnChange() {
        const CarrierChecked = this.checkboxCarriers.checked;
        if(!CarrierChecked && this.validateIncludePayeeType()){
            this.checkboxPageBreakAfterManager.visible = false;
            this.switchGroupByCarrierManager.visible = false;
            this.excludabletextboxCarrierMng.textbox.visible = false;
            this.excludabletextboxCarrierMng.checkbox.visible = false;
            this.checkboxInclOnlyItemsWithCarrier.visible = false;
            this.excludabletextboxCarrierMng.textbox.text = "";
            this.checkboxPageBreakAfterManager.checked = false;

        }
        else {
            this.checkboxPageBreakAfterManager.visible = true;
            this.switchGroupByCarrierManager.visible = true;
            this.excludabletextboxCarrierMng.visible = true;
            this.excludabletextboxCarrierMng.textbox.visible = true;
            this.excludabletextboxCarrierMng.checkbox.visible = true;
            this.checkboxInclOnlyItemsWithCarrier.visible = true;
            if(!this.validateIncludePayeeType()){
                Snackbar.showWarningSnackbar("At least ONE payee must be checked to run this report");
                this.checkboxCarriers.checked = true;
            }
        }
    }
}
